
import { Component, Injector, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { TemplateTextService } from 'tnx-admin-service/templatetext/services';
import {
    ComponentContextService, DataFormBase,
    EditorControlSchema, EventData, FormSchemaBase,
    RadioButtonListControlSchema, TextAreaControlSchema, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'templatetext-form',
    templateUrl: './templatetext-form.component.html',
    styleUrls: ['./templatetext-form.component.scss'],
    providers: [ComponentContextService],
})
export class TemplateTextFormComponent extends DataFormBase implements OnInit {

    contentHtml: string;

    constructor(
        protected _injector: Injector,
        private _templateTextService: TemplateTextService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._templateTextService;
        if (this._isFormAddNew()) {
            this.model.data.templateContentType = 'text';
        }
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),
            new TextControlSchema({
                field: 'title',
                label: 'Tên biểu mẫu',
                required: true
            }),
            new RadioButtonListControlSchema({
                field: 'templateContentType',
                label: 'Loại biểu mẫu',
                mdWidth: 12,
                required: true,
                displayField: 'label',
                valueField: 'value',
                dataSource: [{
                    label: 'Text',
                    value: 'text'
                }, {
                    label: 'Html',
                    value: 'html'
                }],
                onChanged: (evt: EventData) => {
                    evt.formControls['content'].hidden = evt.parentModel.templateContentType != 'text';
                    evt.formControls['contentHtml'].hidden = evt.parentModel.templateContentType != 'html';
                    if (evt.formControls['contentHtml'].hidden) {
                        evt.parentModel.content = evt.parentModel.contentHtml;
                    } else {
                        evt.parentModel.contentHtml = evt.parentModel.content;
                    }
                }
            }),
            new TextAreaControlSchema({
                field: 'content',
                label: 'Nội dung',
                mdWidth: 12,
                required: true
            }),
            new EditorControlSchema({
                field: 'contentHtml',
                label: 'Nội dung Html',
                mdWidth: 12,
                hidden: true,
                height: 300
            }),
            new TextControlSchema({
                field: 'codeModule',
                label: 'Thuộc phân hệ',
                mdWidth: 12
            })
        ];
        this.addSchemaBase();
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        if (this._isFormAddNew()) {
            this.formControls['content'].hidden = false;
        } else {
            this.formControls['content'].hidden = data.templateContentType != 'text';
            this.formControls['contentHtml'].hidden = data.templateContentType != 'html';
            if (!this.formControls['contentHtml'].hidden) {
                data.contentHtml = data.content;
            }
        }
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
        if (!this.formControls['contentHtml'].hidden) {
            this.model.data.content = this.model.data.contentHtml;
        }
    }
}

